import React, { useState, useEffect } from "react";

export const svg = `<svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewbox="0 0 20 20" fill="none"><path fill="currentColor" d="M12.787 5.11a7.57 7.57 0 0 1-.605.358.948.948 0 0 1-.118.042h-.002l-.042.014v3.738c-.02 1.11-.925 2.011-2.022 2.011-1.115 0-2.02-.92-2.02-2.049V5.506l-.163-.057a6.35 6.35 0 0 1-.641-.375c-.457-.29-.9-.574-1.485-.574-1.42 0-2.46 1.48-1.964 2.836.21.598.64.92 1.135 1.253.6.388 1.153.882 1.611 1.441a6.977 6.977 0 0 1 1.325 2.894c.088.415.143.958.186 1.39l.024.232c.105 1.072.83 1.954 2.002 1.954 1.173 0 1.897-.882 2.002-1.954.038-.474.105-1.129.21-1.622a6.859 6.859 0 0 1 1.325-2.894 6.476 6.476 0 0 1 1.611-1.441c.496-.332.925-.655 1.135-1.253.457-1.337-.582-2.817-1.983-2.817-.588 0-1.046.29-1.521.591Z"></path><path fill="currentColor" d="M8.654 6.919v2.343c0 .74.6 1.338 1.344 1.338.725 0 1.326-.598 1.345-1.338V6.92c0-.74-.6-1.357-1.345-1.357A1.368 1.368 0 0 0 8.654 6.92Z"></path></svg>`;

const contentRegExp = /<svg(.*?)>(.*?)<\/svg>/s;
const attrRegExp = /(.*?)="(.*?)"/;
const splitAttrExp = /[\w-]+="[^"]*"/g;

const attributeMap = {
  viewbox: "viewBox",
  class: "className",
};

let instanceId = 0;

function Icon(props) {
  const [, attrs, content] = svg.match(contentRegExp);

  const svgAttributes = {};

  for (const stringAttr of attrs.trim().match(splitAttrExp)) {
    let [, key, value] = stringAttr.match(attrRegExp);
    if (key in attributeMap) key = attributeMap[key];
    svgAttributes[key] = value;
  }

  const [obj, setObj] = useState({ svgAttributes, __html: content });

  // On the client, unique IDs are necessary per instance.
  // We will use the fact that React SSR does not run effects!
  useEffect(() => {
    const ids = svg.matchAll(/id="(.*?)"/gm);
    let html = obj.__html;

    for (const [match, id] of ids) {
      const uniqueID = `${id}-${instanceId}`;
      html = html
        .replace(match, 'id="' + uniqueID + '"')
        .replaceAll(`url(#${id})`, `url(#${uniqueID})`)
        .replaceAll(`"#${id}"`, `"#${uniqueID}"`);
    }

    setObj({ svgAttributes, __html: html });

    instanceId++;
  }, []);

  return (
    <svg
      dangerouslySetInnerHTML={obj}
      {...obj.svgAttributes}
      {...props}
    />
  );
}

export default Object.assign(Icon, { svg });
